/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BuildingConcernedOwnership { 
    budId?: number;
    katuzeKod?: number;
    lv?: number;
    opsubId?: number;
    share?: string;
    shareDenominator?: number;
    shareNumerator?: number;
    subjectName?: string;
    typravKod?: string;
}

